export default __webpack_public_path__ + "static/media/logo2.e3d4b941.png";